import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { SharedModule } from '../shared/shared.module';
import * as fromUsersReducer from '../store/reducers/users.reducer';
import { OverallNetworkStatusPageComponent } from './containers/overall-network-status-page/overall-network-status-page.component';

const overallNetworkStatusPageRoutes: Routes = [
  {
    path: '',
    component: OverallNetworkStatusPageComponent,
    canActivate: [NgxPermissionsGuard],
  },
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(overallNetworkStatusPageRoutes),
    StoreModule.forFeature('user', fromUsersReducer.reducer),
    OverallNetworkStatusPageComponent,
  ],
  declarations: [],
  exports: [OverallNetworkStatusPageComponent],
})
export class OverallNetworkStatusModule {}

